import { render, staticRenderFns } from "./Efootbar.vue?vue&type=template&id=0e487d0f"
import script from "./Efootbar.vue?vue&type=script&lang=js"
export * from "./Efootbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports